
import { useEffect, useCallback, useLayoutEffect } from 'react'

import styles from './index.module.css';

import {
  Outlet,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { ApolloClient, InMemoryCache } from '@apollo/client';

import { authProvider } from "../../auth";
import { PATHS } from "../../paths";
import { MediaContextProvider, Media } from '../../mobile'

import { REFRESH_TOKEN } from '../../constants';
import { BACKEND_URL } from '../../config';
import { REFRESH_MUTATION } from '../../queries/getRefresh';

import { MobileNavigationFooter } from '../Mobile/Navigation';
import { useIsTeacher } from '../../hooks/isTeacher';
import { useIsAdmin } from '../../hooks/isAdmin';

const client = new ApolloClient({
  uri: BACKEND_URL,
  cache: new InMemoryCache(),
});

// TODO: make a page to explain to a user why they are now on the login page
const PATH_FOR_FAILED_AUTH = `${PATHS.LOGIN}`;

function Layout() {
    let navigate = useNavigate();

    const path = useLocation();
    const isLoginPage = path.pathname === PATHS.LOGIN;
    const isClassesPage = path.pathname === PATHS.CLASSES;

    const isClassPage = /^\/classes\/\d+$/.test(path.pathname);

    const isTeacher = useIsTeacher();
    const isAdmin = useIsAdmin();

    const tryRefresh = useCallback(async () => {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);

        if (refreshToken) {
          const refreshRequest = await client.mutate({ mutation: REFRESH_MUTATION, variables: { refreshToken } });

          if (refreshRequest.errors) {
              await authProvider.signout();
              navigate(PATH_FOR_FAILED_AUTH, { replace: true });
          }

          if (refreshRequest?.data?.refresh?.success) {
              await authProvider.signin(refreshRequest?.data?.refresh?.token, refreshRequest?.data?.refresh?.refreshToken);
          } else {
              await authProvider.signout();
              navigate(PATH_FOR_FAILED_AUTH, { replace: true });
          }
        } else {
          navigate(PATH_FOR_FAILED_AUTH, { replace: true });
        }
    }, [navigate])

    useEffect(() => {

      if (isAdmin) {
          localStorage.setItem('theme', 'light');
      }
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
        document.documentElement.setAttribute('data-theme', 'light');
      } else {
        let theme = localStorage.getItem('theme')
        if (theme == null || theme != 'light' && theme != 'dark') {
            localStorage.setItem('theme', 'dark');
            theme = 'dark';
        }
        document.documentElement.setAttribute('data-theme', theme);
      }
    }, [isAdmin]);

    useEffect(() => {
        const intervalId = setInterval(() => tryRefresh(), 29 * 60 * 1000); // 29 minutes

        return () => clearInterval(intervalId);
    }, [tryRefresh]);

    useLayoutEffect(() => {
        const onVisibilityChange = async () => {
            if (document.visibilityState === 'visible' && document.location.pathname !== '/signup') {
                // Tab reopened - user the refresh token
                await tryRefresh()
            }
        };

        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => document.removeEventListener("visibilitychange", onVisibilityChange);
    }, [tryRefresh]);

  return (
      <MediaContextProvider>
        <Media at='mobile'>
          {isTeacher ? (
            <div className={(isLoginPage || isClassesPage || isClassPage) ? styles.mobile : ''} >
              <Outlet />
              <MobileNavigationFooter />
            </div>
          ): (<Outlet />)}
        </Media>
        <Media greaterThan='mobile'>
            <Outlet />
        </Media>
      </MediaContextProvider>
  );
}

export { Layout };
